/**
 * Zentrale Breakpoints für Layout (App vs. Tablet/Web).
 * Ein Wert, eine Bedeutung: unterhalb = „App-Modus“ (einspaltig, Drawer überlagert),
 * ab Breakpoint = „breites Viewport“ (z. B. Sidebar fix, Liste+Detail nebeneinander).
 */
export const WIDE_VIEWPORT_BREAKPOINT = 900;

/**
 * Formular- und Tabellenstufen. Die App-Shell bleibt bei
 * WIDE_VIEWPORT_BREAKPOINT (900).
 */
export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;

/**
 * Spalten der Formularfläche aus der gemessenen Containerbreite.
 * Unter 520 eine Spalte, von 520 bis 839 zwei, ab 840 drei.
 * FORM_COLS_HYSTERESIS hält die höhere Zahl, wenn eine Scrollbar von 15 px
 * die Breite nur knapp unter die Schwelle zieht. theme.space.lg ist im
 * Klar-Theme 14 und würde bei 505 und 825 px noch umspringen.
 */
export const FORM_COLS_2_MIN = 520;
export const FORM_COLS_3_MIN = 840;
export const FORM_COLS_HYSTERESIS = 16;

/**
 * Einheitliche maximale Inhaltsbreite für Arbeitsflächen (Board, Listen, Akte).
 * Auf schmalen Geräten greift width:100%.
 */
export const CONTENT_MAX_WIDTH = 1280;

/** Inhaltshöhe der Tab-Leiste, ohne den Safe-Area-Abstand darunter. */
export const APP_BOTTOM_BAR_HEIGHT = 56;
